export const Logo = ({ fill }: React.SVGProps<SVGPathElement>) => (
  <>
    <path
      d="M192 154.871V64H101.123V90.8822H117.724V80.6001H175.392V138.257H154.876V101.129H64V192H154.876V165.125H138.276V175.393H80.6011V117.729H101.131V154.871H192ZM138.261 138.264H117.732V117.729H138.261V138.264Z"
      fill={fill}
    />
  </>
);
